module.exports = __webpack_public_path__ + "static/media/icon-trash-dark.a239d57b.svg";